import $http from '@/libs/axios'

class SubUserAPIs {
  static async update(payload: any) {
    return (await $http.put('/subusers/update', payload)).data
  }

  static async getManagers() {
    return (await $http.get('/subusers/managers')).data
  }

  public static async create(data: any) {
    return (await $http.post('/subusers/create', data)).data
  }

  public static async delete(subuserId: number, all = false) {
    const data = {
      id: subuserId,
      all,
      _method: 'DELETE',
    }
    return (await $http.delete('/subusers/delete', { data })).data
  }

  static async resendVerification(userId: number) {
    return (await $http.get(`/subusers/resend-verification/${userId}`)).data
  }

  static async validateUserName(data: any) {
    return (await $http.post('/subusers/validate', data)).data
  }
}

export default SubUserAPIs
